export default __webpack_public_path__ + "static/media/yt.e7e2ca77.png";